import React, { useEffect } from 'react'
import { type StripeElements, type Stripe } from '@stripe/stripe-js'
import {
  ExpressCheckoutElement,
  type ExpressCheckoutElementProps,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'

interface Props extends ExpressCheckoutElementProps {
  setStripeElements: (stripeElements: StripeElements) => void
  setStripeClient: (stripeClient: Stripe) => void
}

export const AblefyStripeExpressPaymentElement = (props: Props) => {
  const { setStripeElements, setStripeClient, ...rest } = props
  const elements = useElements()
  const stripe = useStripe()

  useEffect(() => {
    if (elements) {
      setStripeElements(elements)
    }
    if (stripe) {
      setStripeClient(stripe)
    }
  }, [elements, stripe])

  return <ExpressCheckoutElement {...rest} />
}
